const AVATAR_SIZE = {
  18: '18',
  SM: '21',
  24: '24',
  26: '26',
  28: '28',
  32: '32',
  36: '36',
  30: '30',
  M: '44',
  52: '52',
  54: '54',
  XL: '64',
  75: '75',
  125: '125',
};

export default AVATAR_SIZE;
